/**
 * PostHog multivariate flag for the pre-checkout payment guidance experiment.
 *
 * - `control` — nothing changes.
 * - `test`    — an inline notice above the pay button (no extra click).
 * - `test_b`  — an interstitial modal the student must dismiss before checkout.
 *
 * The country gate below is applied in code on top of the flag: students
 * outside the target countries never see either treatment, whatever variant
 * PostHog assigns them, so the experiment only measures the cohort it can help.
 */
export const PRE_CHECKOUT_PAYMENT_GUIDANCE_FLAG =
  'pre_checkout_payment_guidance';

export type TPreCheckoutPaymentGuidanceVariant = 'control' | 'test' | 'test_b';

/** Which pay button the guidance sits next to. Recorded on every event. */
export type TPreCheckoutPaymentGuidanceSurface =
  | 'course_monthly_plan'
  | 'course_one_time'
  | 'billing_plan';

/**
 * ISO2 codes of the countries where first-payment declines cluster around
 * cards that have online / international transactions switched off (Stripe
 * `transaction_not_allowed` and the Indian share of `do_not_honor`). Sourced
 * from the Aug–Sep 2026 payment failure readout; extend as the data changes.
 */
export const PRE_CHECKOUT_PAYMENT_GUIDANCE_COUNTRIES = [
  'IN',
  'MY',
  'BD',
  'MV',
  'LK',
];
